import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserRoleE } from '@enums/user-role.enum';
import { UserHelperService } from '@helpers/user-helper.service';

@Injectable()
export class IsAlreadyLoggedGuard implements CanActivate {
  constructor(
    private router: Router,
    @Inject(UserHelperService)
    private userHelperService: UserHelperService
  ) {}

  public canActivate(): boolean {
    const token = this.userHelperService.getIdToken();
    const userAttributes = this.userHelperService.getUserAttributes();
    if (token && userAttributes) {
      let redirectTo = ['/panel/dashboard'];
      const cognitoGroups = userAttributes['cognito:groups'];
      if (cognitoGroups === UserRoleE.AGENT || cognitoGroups.includes(UserRoleE.AGENT)) redirectTo = ['/panel/chat'];

      this.router.navigate(redirectTo);
      void this.router.navigate(redirectTo);
    }
    return true;
  }
}
